import FormEditorContainer from './src/main'

FormEditorContainer.install = function (Vue) {
  Vue.component(FormEditorContainer.name, FormEditorContainer)
}

export default FormEditorContainer
